export default __webpack_public_path__ + "static/media/alexanderpool.5e2fd98f.jpg";